import React from 'react';

import { useHistory } from 'react-router-dom';

import { LoginCallback, useOktaAuth } from '@okta/okta-react';

const CustomLoginCallback = () => {
  const { authState } = useOktaAuth();
  const history = useHistory();

  React.useEffect(() => {
    if (authState?.isAuthenticated && !sessionStorage.getItem('ssoEmail')) {
      history.replace('/okta');
    }
  }, [authState?.isAuthenticated, history]);

  return <LoginCallback />;
};

export default CustomLoginCallback;
